import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './BookOfBusinessRow.module.css';
import defStyles from './DeficiencyByLobRow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';

interface BookOfBusinessHeaderProps {
  readonly helmet: HeaderHelmetProps;
  readonly showPercentPointChange?: boolean;
  readonly showDollarChange?: boolean;
  readonly includePDLR?: boolean;
  readonly showIncludePy2?: boolean;
  readonly sectionKey: string;
}

export default function BookOfBusinessHeader({
  helmet,
  showPercentPointChange,
  showDollarChange,
  includePDLR,
  sectionKey
}: BookOfBusinessHeaderProps) {
  const { showBenchmark, year } = useContext(AppContext);

  const renderContent = () => {
    switch (sectionKey) {
      case 'liabilities-analysis':
        return (
          <div
            className={`${defStyles.container} ${showBenchmark ? '' : defStyles.collapse}`}
            data-testid="book-of-business-row-header">
            <HeaderHelmet {...helmet} />
            <h5 className="column_align_right">{year}($'s)</h5>
            <h5 className="column_align_right">{year}(%'s)</h5>
            <h5 className="column_align_right">{year - 1}($'s)</h5>
            <h5 className="column_align_right">{year - 1}(%'s)</h5>
            <h5 className="column_align_right">{year - 2}($'s)</h5>
            <h5 className="column_align_right">{year - 2}(%'s)</h5>
          </div>
        );
      case 'affiliates':
      case 'revenues-and-expenses':
        return (
          <div
            className={`${defStyles.container} ${showBenchmark ? '' : defStyles.collapse}`}
            data-testid="book-of-business-row-header">
            <HeaderHelmet {...helmet} />
            <h5 className="column_align_right">{year}</h5>
            <h5 className="column_align_right">{year} % of Total</h5>
            <h5 className="column_align_right">{year - 1}</h5>
            <h5 className="column_align_right">{year - 1} % of Total</h5>
            <h5 className="column_align_right">{year - 2}</h5>
            <h5 className="column_align_right">{year - 2} % of Total</h5>
          </div>
        );
      default:
        return (
          <div
            className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}
            data-testid="book-of-business-row-header">
            <HeaderHelmet {...helmet} />
            <h5 className="column_align_right">{showPercentPointChange ? '%/Pt. Change' : ''}</h5>
            <h5 className="column_align_right">{showDollarChange ? '$ Change' : ''}</h5>
            <h5 aria-hidden="true"></h5>
            <h5 aria-hidden="true"></h5>
            <h5 className="column_align_right">{year} Premium</h5>
            <h5 className="column_align_right">{year} % of Total</h5>
            <h5 className="column_align_right">{includePDLR ? `${year} PDLR*` : ''}</h5>
            <h5 className="column_align_right">{year - 1} Premium</h5>
            <h5 className="column_align_right">{year - 1} % of Total</h5>
            <h5 className="column_align_right">{includePDLR ? `${year - 1} PDLR*` : ''}</h5>
          </div>
        );
    }
  };

  return <div>{renderContent()}</div>;
  // return (
  //   <div>
  //     {showIncludePy2 ? (
  //       <div className={`${defStyles.container} ${showBenchmark ? '' : defStyles.collapse}`} data-testid="book-of-business-row-header">
  //         <HeaderHelmet {...helmet} />

  //         <h5 className="column_align_right">{year}($'s)</h5>
  //         <h5 className="column_align_right">{year}(%'s)</h5>
  //         <h5 className="column_align_right">{year - 1}($'s)</h5>
  //         <h5 className="column_align_right">{year - 1}(%'s)</h5>
  //         <h5 className="column_align_right">{year - 2}($'s)</h5>
  //         <h5 className="column_align_right">{year - 2}(%'s)</h5>
  //       </div>
  //     ) : (
  //       <div className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`} data-testid="book-of-business-row-header">
  //         <HeaderHelmet {...helmet} />

  //         <h5 className="column_align_right">{showPercentPointChange ? '%/Pt. Change' : ''}</h5>
  //         <h5 className="column_align_right">{showDollarChange ? '$ Change' : ''}</h5>
  //         <h5 aria-hidden="true"></h5>
  //         <h5 aria-hidden="true"></h5>
  //         <h5 className="column_align_right">{year} Premium</h5>
  //         <h5 className="column_align_right">{year} % of Total</h5>
  //         <h5 className="column_align_right">{includePDLR ? `${year} PDLR*` : ''}</h5>
  //         <h5 className="column_align_right">{year - 1} Premium</h5>
  //         <h5 className="column_align_right">{year - 1} % of Total</h5>
  //         <h5 className="column_align_right">{includePDLR ? `${year - 1} PDLR*` : ''}</h5>
  //       </div>
  //     )}
  //   </div>

  // );
}
